var video_viewer_default = {
  "video_player": "Z-m2E",
  "videoOverlay": "_7skgj",
  "video_container": "jE3It"
};
export {
  video_viewer_default as default
};
//# sourceMappingURL=video-viewer-scss.js.map
